import styles from './ThemeSwitch.module.css';
import sunIcon from '../../assets/icons/theme-toggle-light.png';
import moonIcon from '../../assets/icons/theme-toggle-dark.png';

const ThemeSwitch = ({ theme, toggleTheme }) => {
    return (
        <div className={styles.toggleContainer} onClick={toggleTheme}>
            <div className={`${styles.option} ${theme === 'light' ? styles.active : ''}`}>
                <img src={sunIcon} alt="Sun" className={styles.icon} />
            </div>
            <div className={`${styles.option} ${theme === 'dark' ? styles.active : ''}`}>
                <img src={moonIcon} alt="Moon" className={styles.icon} />
            </div>
        </div>
    );
};

export default ThemeSwitch;
